import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

export function isLocalUrl(url: string) {
  return url.startsWith( getBootstrapData().settings.base_url );
}
